<template>
  <div class="production_wrap">
    <div class="production_img">
      <div class="img_tit">上下游协同管理</div>
      <div class="img_desc">通过信息共享、资源整合和流程优化，实现供应链上下游企业间的高效协作与整体效益最大化。</div>
    </div>
    <!-- 注释掉产品介绍模块
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_left">
          <img src="../../assets/img/tupianright.png" alt="" />
        </div>
        <div class="inner_center">
          <div class="production_title">产品介绍</div>
          <div class="production_desc">"柳叶云"是一款专门为医疗器械行业定制的供应链管理软件</div>
        </div>
        <div class="inner_right">
          <img src="../../assets/img/tupianleft.png" alt="" />
        </div>
      </div>
    </div>
    -->
    <!-- 注释掉柳叶云描述模块
    <div class="production_box">
      <div class="production_item">
        <div class="left_content">
          <div class="item_left">
            <img src="../../assets/img/12.74947a2 (1).png" alt="" />
          </div>
          <div class="right_tit">柳叶云</div>
        </div>
        <div class="right_desc">
          柳叶云"是一款专门为医疗器械高值耗材行业定制的供应链管理软件，"骨科"是医疗器械中管理难度最大、经营效率提高需求最迫切的行业而"柳叶云"为骨科行业量身定制，帮助骨科行业的广大经销商和生产厂商降本增效。
        </div>
      </div>
    </div>
    -->
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_left">
          <img src="../../assets/img/tupianright.png" alt="" />
        </div>
        <div class="inner_center" style="width: 40%;">
          <div class="production_title">产品优势及特点</div>
          <div class="production_desc">
            "柳叶云"是一款专门为医疗器械行业定制的供应链管理软件。
          </div>
        </div>
        <div class="inner_right">
          <img src="../../assets/img/tupianleft.png" alt="" />
        </div>
      </div>
    </div>
    <div class="production_content">
      <div class="production_card">
        <ProCard :procardList="procardList" />
      </div>
      <AdvantageCard />
    </div>
    <MobileReservationDialog :visible.sync="showMobileDialog" />
  </div>
</template>

<script>
import ProCard from './ProCard.vue'
import AdvantageCard from './AdvantageCard.vue'
import MobileReservationDialog from '@/components/MobileReservationDialog.vue'

export default {
  data() {
    return {
      procardList: [
        {
          tit: '上下游协同管理'
        }
      ],
      showMobileDialog: false
    }
  },
  components: {
    ProCard,
    AdvantageCard,
    MobileReservationDialog
  }
}
</script>

<style lang="scss" scoped>
.production_wrap {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;

  .production_img {
    width: 100%;
    height: 600PX;
    background: url('../../assets/img/banner1.jpg') center center no-repeat;
    background-size: cover;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    padding: 0 20PX;
    text-align: center;

    @media screen and (max-width: 768PX) {
      height: auto;
      padding: 60PX 20PX;
    }

    .img_tit {
      font-size: 60PX;
      font-weight: bold;
      @media screen and (max-width: 768PX) {
        font-size: 28PX;
      }
    }

    .img_desc {
      font-size: 28PX;
      margin-top: 20PX;
      max-width: 1200PX;
      line-height: 1.5;
      @media screen and (max-width: 768PX) {
        font-size: 16PX;
        margin-top: 15PX;
      }
    }
  }



  .production_content {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;

    .production_card {
      width: 100%;
      max-width: 1200PX;
      margin: 0 auto;
      display: flex;
      justify-content: center;

      @media screen and (max-width: 768PX) {
        padding: 0 15PX;
      }
    }
  }
}
</style>